import { ColumnTypes } from '@makyoapp/makyo-sdk/models/Table.js'
import { IActionRepeaterValue, IActionSettings, IActionType } from '@makyoapp/makyo-common'

import { ActionExternalData, SimulateAction, SimulateActionOptions } from '@/core/models/actions/types'

import { Option } from './types'

export enum ActionDataType {
  ColumnData = 1,
  ProfileData = 2,
  SingleCell = 4,
  Icon = 8,
  PageTitle = 16,
  Image = 32,
  CurrentRow = 64,
  CurrentListItem = 128,
  Column = 256,
  DateTime = 512,
  ClearValue = 1024,
  SessionID = 2048,
  Comment = 4096,
  ActionOutput = 8192,
  UniqueID = 16384,
  GlobalVariable = 4194304,
  NewsletterEmail = 8388608,
}

export type ActionInputdata = {
  value?: any
  tableId?: string
  dataType?: ActionDataType
  rowIndex?: number
  colId?: string
}

export type NodeOutputOption = Option<
  | {
      actionId: string
      colId?: string
      colType?: ColumnTypes
      tableId?: string
    }
  | string
>

export type ActionHandlerOption = {
  sequenceId: string
  actionId: string
  settings: IActionSettings
  allActions?: IActionRepeaterValue[]
}

export type ActionHandlers = {
  [K in IActionType]?: (opts: ActionHandlerOption) => void | Promise<void | string>
}

export interface IActionSequence {
  sequenceId: string
  actions: IActionRepeaterValue[]
  queue: IActionRepeaterValue[]
  outputCache: Map<string, any>
  redirectCache: Map<string, { rowId: string; tableId: string }>
  external?: ActionExternalData
  triggerSource?: {
    id?: string
    label?: string
    type?: 'page' | 'component' | 'menu' | 'dialog'
    tableId?: string
    rowIndex?: number
    rowId?: string
  }
  elRef?: React.RefObject<any>
  multipleOptions?: {
    tableId: string
    rowIds: string[]
  }
}

export type { ActionExternalData, SimulateAction, SimulateActionOptions }
